import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import campus from '../Asset/images/campus.jpg';
import read from '../Asset/images/studentread.jpg';

/* ── SVG Icons ──────────────────────────────────────────────── */
const ArrowRight = () => (
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="10" x2="17" y2="10" /><polyline points="11 4 17 10 11 16" />
  </svg>
);

const TargetIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
  </svg>
);

const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
  </svg>
);

const StarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const GlobeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const ZapIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const SeedlingIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22V12M12 12C12 7 7 3 2 3c0 5 4 9 10 9zM12 12c0-5 5-9 10-9-1 5-5 9-10 9z" />
  </svg>
);

const BookIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

const UserCheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="8.5" cy="7" r="4" />
    <polyline points="17 11 19 13 23 9" />
  </svg>
);

const PaletteIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
    <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
    <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
    <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
    <path d="M12 2C6.5 2 2 6.5 2 12a10 10 0 0 0 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
  </svg>
);

const MonitorIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

const PersonIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
  </svg>
);

const LockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

/* ── Animated counter hook ──────────────────────────────────── */
const useCounter = (target, duration = 1800) => {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started.current) {
        started.current = true;
        const steps = 50;
        const interval = duration / steps;
        let step = 0;
        const timer = setInterval(() => {
          step++;
          setValue(Math.round(target * (step / steps)));
          if (step >= steps) { clearInterval(timer); setValue(target); }
        }, interval);
      }
    }, { threshold: 0.5 });
    observer.observe(el);
    return () => observer.disconnect();
  }, [target, duration]);

  return [value, ref];
};

/* ── Data ───────────────────────────────────────────────────── */
const VALUES = [
  { num: '01', icon: <StarIcon />,    title: 'Excellence',     desc: 'Pursuing the highest standards in academics and personal development.' },
  { num: '02', icon: <ShieldIcon />,  title: 'Integrity',      desc: 'Building trust through honesty, respect, and ethical conduct.' },
  { num: '03', icon: <GlobeIcon />,   title: 'Global Mindset', desc: 'Preparing students to thrive in our interconnected world.' },
  { num: '04', icon: <ZapIcon />,     title: 'Innovation',     desc: 'Embracing creativity and forward-thinking approaches to learning.' },
  { num: '05', icon: <UsersIcon />,   title: 'Community',      desc: 'Fostering collaboration between students, parents, and educators.' },
  { num: '06', icon: <SeedlingIcon />, title: 'Growth',        desc: 'Cultivating resilience and a lifelong passion for discovery.' },
];

const WHY_FEATURES = [
  { icon: <BookIcon />,     title: 'British Curriculum',     desc: 'World-class standards preparing students for global success.' },
  { icon: <UserCheckIcon />, title: 'Expert Educators',      desc: 'Qualified, passionate teachers dedicated to student excellence.' },
  { icon: <PaletteIcon />,  title: 'Holistic Development',   desc: 'Balancing academics with arts, sport, and character building.' },
  { icon: <MonitorIcon />,  title: 'Modern Facilities',      desc: 'State-of-the-art learning spaces and technology integration.' },
  { icon: <PersonIcon />,   title: 'Small Class Sizes',      desc: 'Personalised attention ensuring every child flourishes.' },
  { icon: <LockIcon />,     title: 'Safe Environment',       desc: 'A nurturing community where students feel valued and secure.' },
];

/* ── Component ──────────────────────────────────────────────── */
const About = () => {
  const [years, yearsRef]    = useCounter(3);
  const [students, studRef]  = useCounter(145);
  const [sat, satRef]        = useCounter(98);

  return (
    <div className="about-page">

      {/* ── 1. Hero Banner ───────────────────────────────────── */}
      <section className="about-hero">
        <div className="about-container">
          <div className="hero-inner">
            <div className="hero-tag">
              <span className="hero-tag-dot" />
              <span className="hero-tag-text">About Star Hacs International School</span>
            </div>
            <h1 className="about-hero-title">
              Shaping <em>Tomorrow's</em><br />Leaders Today
            </h1>
            <p className="about-hero-sub">
              At Star Hacs International School, we believe every child holds the potential to achieve
              greatness. We nurture excellence, build character, and open doors to a future full of possibility.
            </p>
            <div className="hero-cta-row">
              <Link to="/application" className="btn btn-primary">
                Apply Now <ArrowRight />
              </Link>
              <Link to="/contact" className="btn btn-outline-white">
                Schedule a Visit
              </Link>
            </div>
            <div className="scroll-hint">
              <span className="scroll-hint-line" />
              Scroll to explore
            </div>
          </div>
        </div>
      </section>

      {/* ── 2. Our Story ─────────────────────────────────────── */}
      <section className="story-section">
        <div className="about-container">
          <div className="story-grid">

            {/* Image stack */}
            <div className="story-images">
              <div className="story-img-frame" aria-hidden="true" />
              <div className="story-img-main">
                <img src={campus} alt="Star Hacs campus" />
                <span className="story-pill">Est. 2021</span>
              </div>
              <div className="story-img-secondary">
                <img src={read} alt="Students learning" />
              </div>
            </div>

            {/* Text */}
            <div className="story-content">
              <span className="section-eyebrow">Our Story</span>
              <h2 className="section-title">A Journey of <em>Excellence</em></h2>
              <p className="story-body">
                Star Hacs International School was born from a simple yet powerful vision: to create a
                learning sanctuary where every child's unique potential is recognised, nurtured, and
                celebrated. Since our founding, we have been committed to delivering world-class
                education that reaches far beyond the textbook.
              </p>
              <p className="story-body">
                Our approach blends the rigorous British curriculum with innovative teaching methods,
                building an environment where students don't simply learn — they discover, explore,
                and truly thrive. We have built a community where academic excellence meets character.
              </p>

              {/* Animated stats */}
              <div className="story-stats">
                <div className="story-stat">
                  <span className="story-stat-number" ref={yearsRef}>{years}+</span>
                  <span className="story-stat-label">Years of Excellence</span>
                </div>
                <div className="story-stat">
                  <span className="story-stat-number" ref={studRef}>{students}+</span>
                  <span className="story-stat-label">Happy Students</span>
                </div>
                <div className="story-stat">
                  <span className="story-stat-number" ref={satRef}>{sat}%</span>
                  <span className="story-stat-label">Parent Satisfaction</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── 3. Mission & Vision ──────────────────────────────── */}
      <section className="mv-section">
        <div className="about-container">
          <div className="mv-header">
            <span className="section-eyebrow">Purpose & Direction</span>
            <h2 className="section-title">Our Mission &amp; <em>Vision</em></h2>
          </div>

          <div className="mv-grid">
            <div className="mv-card">
              <div className="mv-icon-box"><TargetIcon /></div>
              <h3 className="mv-card-title">Our Mission</h3>
              <p className="mv-card-text">
                To provide holistic education that empowers students to achieve academic excellence,
                develop strong character, and become responsible global citizens through innovative
                teaching and a nurturing environment.
              </p>
            </div>

            <div className="mv-card">
              <div className="mv-icon-box"><EyeIcon /></div>
              <h3 className="mv-card-title">Our Vision</h3>
              <p className="mv-card-text">
                To be a leading educational institution that inspires lifelong learning, fosters
                creativity, and prepares students to meet tomorrow's challenges with confidence,
                integrity, and compassion.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── 4. Core Values ───────────────────────────────────── */}
      <section className="values-section">
        <div className="about-container">
          <div className="values-header">
            <span className="section-eyebrow">What We Stand For</span>
            <h2 className="section-title">Our Core <em>Values</em></h2>
            <p className="section-body" style={{ marginTop: 16 }}>
              These principles guide everything we do and shape the character of our entire community.
            </p>
          </div>

          <div className="values-grid">
            {VALUES.map((v) => (
              <div className="value-card" key={v.num}>
                <span className="value-num" aria-hidden="true">{v.num}</span>
                <div className="value-icon-box">{v.icon}</div>
                <h3 className="value-title">{v.title}</h3>
                <p className="value-desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── 5. Why Star Hacs ─────────────────────────────────── */}
      <section className="why-section">
        <div className="about-container">
          <div className="why-inner">
            <div className="why-left">
              <span className="section-eyebrow">What Sets Us Apart</span>
              <h2 className="section-title">Why <em>Star Hacs?</em></h2>
              <p className="section-body">
                A purposefully designed environment where every element — from curriculum to culture
                — exists to help your child reach their full potential.
              </p>
              <Link to="/academics" className="btn btn-outline-white" style={{ marginTop: 32 }}>
                Explore Academics <ArrowRight />
              </Link>
            </div>

            <div className="why-features">
              {WHY_FEATURES.map((f) => (
                <div className="why-feature" key={f.title}>
                  <div className="why-feature-icon">{f.icon}</div>
                  <h4 className="why-feature-title">{f.title}</h4>
                  <p className="why-feature-desc">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── 6. CTA ───────────────────────────────────────────── */}
      <section className="about-cta">
        <div className="about-container">
          <div className="cta-inner">
            <span className="cta-overline" aria-hidden="true" />
            <h2 className="cta-title">Begin Your <em>Journey</em> With Us</h2>
            <p className="cta-desc">
              Join a community where your child's potential becomes their reality.
              Experience education designed to transform lives.
            </p>
            <div className="cta-buttons">
              <Link to="/admissions" className="btn btn-primary">
                Apply Now <ArrowRight />
              </Link>
              <Link to="/contact" className="btn btn-outline-red">
                Schedule a Visit
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;